import React, {useEffect} from 'react';
import {redirectToAppOrDownload} from 'utils';


interface IDefaultProps {
}

const AppStore: React.FC<IDefaultProps> = () => {
    useEffect(() => {
        redirectToAppOrDownload();
    }, []);

    return (
        <main className="h-screen bg-white flex justify-center items-center">
            <div className="pb-20 px-20">
                <p className="font-medium">
                    Hang on. Redirecting ...
                </p>
            </div>
        </main>
    );
};

export default AppStore;
